import "../../../assets/styles/containers/_summaryRatings.scss";
import FlagIcon from "@mui/icons-material/Flag";

const SummaryRating = ({ rating }) => {
  return (
    <div className="summary_rating_block">
      {rating?.map((item) => (
        <div className="summary_rating_container" key={item?.summary?.id || item?.id}>
          <div className="rating_block" style={{ backgroundColor: `${item?.summary?.color || item?.color || item?.Color}` }}>
            {(item?.include_in_summary === "1" || item?.include_in_summary === 1) && <FlagIcon style={{ color: "#ffffff", fontSize: "10px", position: "relative", top: "-4px", left: "0.5px" }} />}
          </div>
          <div className="summary_rating">
            {item?.summary?.name || item?.name || item?.title || item?.Name}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryRating;
